import styled from 'styled-components';
import { ACTION_CONFIG_HEADER_HEIGHT } from 'automation-ui-core/constants/ui';
import { jsx as _jsx } from "react/jsx-runtime";
// use a small height to avoid a visual shift of other components on display and ensure browser compatability
const StyledInputIndicator = styled.div.withConfig({
  displayName: "DataPassingInputIndicator__StyledInputIndicator",
  componentId: "k3352a-0"
})(["position:absolute;height:0.01px;"]);
const ARROW_SIDE_PX = 24;
const StyledArrow = styled.div.withConfig({
  displayName: "DataPassingInputIndicator__StyledArrow",
  componentId: "k3352a-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    height: `${ARROW_SIDE_PX}px`,
    width: `${ARROW_SIDE_PX}px`,
    borderLeft: `1px solid ${theme.color['border-core-default']}`,
    borderBottom: `1px solid ${theme.color['border-core-default']}`,
    transform: 'rotate(45deg)',
    background: theme.color['fill-surface-default'],
    position: 'relative',
    top: '5px',
    left: '5px'
  };
});
const ClippedStyledArrowWrapper = styled.div.withConfig({
  displayName: "DataPassingInputIndicator__ClippedStyledArrowWrapper",
  componentId: "k3352a-2"
})(["width:17px;height:34px;position:relative;"]);
const DataPassingInputIndicator = ({
  targetInputRef,
  dataPanelRef,
  heightOffset = 0
}) => {
  if (!targetInputRef || !targetInputRef.current || !dataPanelRef || !dataPanelRef.current) {
    return null;
  }

  // left coordinate is the data panel left edge. Coordinates are tweaks to align
  // with the left edge and show the full triangle.
  const leftOffset = dataPanelRef.current.offsetLeft - Math.hypot(ARROW_SIDE_PX, ARROW_SIDE_PX) / 2 - 1;
  const topOffset = heightOffset + ACTION_CONFIG_HEADER_HEIGHT; // Add ACTION_CONFIG_HEADER_HEIGHT to account for a migration of the action config header layout

  return /*#__PURE__*/_jsx(StyledInputIndicator, {
    style: {
      left: leftOffset,
      top: topOffset
    },
    children: /*#__PURE__*/_jsx(ClippedStyledArrowWrapper, {
      "data-test-id": "data-passing-panel-input-target-indicator",
      children: /*#__PURE__*/_jsx(StyledArrow, {})
    })
  });
};
export default DataPassingInputIndicator;